import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table, Descriptions, Spin, Tooltip, message, Select } from 'antd';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { showErrorInNotification, formatMoney, copyStringToClipboard } from '../../lib/util';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import { COLORS } from '../theme';
import Paragraph from 'antd/lib/typography/Paragraph';
import FilterFixedInput from '../../components/filter_fixed_input';


const queryString = require('query-string');

const transaction_cols = ({
  onViewDetailClicked,
  onExpand,
  expanded_keys = []
}) => [
    {
      title: "Type",
      dataIndex: "type",
      key: 'type',
      className: 'center-align',
      width: 53,
      render: (value, row, index) => {
        return <div title={value == 'C' ? "Credit" : (value == 'D' ? "Debit" : "N/A")} className={value === 'D' ? 'debit-circle' : value == 'C' ? 'credit-circle' : 'na-circle'}>
          {value || "-"}
        </div>
      }
    },
    {
      title: "Txn Date",
      dataIndex: "txn_date",
      width: 120,
      key: 'txn_date'
    }, {
      title: "Tran ID",
      dataIndex: "transaction_id",
      key: 'transaction_id',
      width:100,

    }, {
      title: "Particular",
      dataIndex: "description",
      key: 'description',
    }, {
      title: "Amount",
      dataIndex: "amount",
      width: 100,
      key: 'amount',
      className: 'right-align',
      render: (value, row, index) => formatMoney(value, 2, '.', ',')

    },
    {
      title:"STATUS",
      width:60,
      dataIndex:'status',
      key:'status',
      render:(status)=><div style={{
          display:'flex',
          justifyContent:'center'
      }}
      >
          {status?
          <Tooltip title={<div className='log-text'>
              {(status||"")}
          </div>}
          placement='bottomRight'
          arrowPointAtCenter
          autoAdjustOverflow
          overlayClassName={status?'error-tooltip side-scroll':''}
          >
          <div 
          onClick={(e)=>{
              copyStringToClipboard(status);
              message.success("Copied")
          }}
          className='hand-cursor' style={{
          height:10,minHeight:10,
          width:10,minWidth:10,
          borderRadius:5,
          backgroundColor:status?COLORS.danger_primary:COLORS.success_primary,
      }}>
      </div></Tooltip>
      :
      <div style={{
          height:10,minHeight:10,
          width:10,minWidth:10,
          borderRadius:5,
          backgroundColor:status?COLORS.danger_primary:COLORS.success_primary,
      }}>
      </div>
      }
      </div>,
      className:'center-align'
  },
    // {
    //   title: "",
    //   width: 100,
    //   key: 'expand',
    //   className: 'right-align',
    //   render: (data) => {
    //     return <div
    //       className='hand-cursor'
    //       onClick={() => {
    //         onExpand(`${data.id}`)
    //       }}
    //       style={{
    //         display: 'flex',
    //         color: COLORS.secondary,
    //         flexDirection: 'row',
    //         justifyContent: 'flex-end'
    //       }}>
    //       {expanded_keys.includes(data.id) ? "LESS" : "MORE"} <ExpandMoreOutlined style={{
    //         transform: `rotate(${expanded_keys.includes(`${data.id}`) ? 180 : 0}deg)`,
    //         transition: 'transform 200ms '
    //       }} />

    //     </div>
    //   }
    // }
    // {
    //   title: "Age(Days)",
    //       dataIndex: "age",
    //       width: 100,
    //       key:'age'
    // },
    // {
    //   title: "",
    //       dataIndex: "id",
    //       width: 50,
    //       key:'action',
    //       render:(id)=><Link to={`/recon/${id}`} onClick={(e)=>{
    //         e.preventDefault();
    //         e.stopPropagation();
    //         typeof onViewDetailClicked==='function'&&onViewDetailClicked(id)
    //       }}><Button type='link' >View</Button></Link>
    // }
  ]

class FileNotTransferredTransactions extends Component {
  constructor(props) {
    super(props)

    this.datatype = this.props.match.params.datatype_id;

    this.state = {
      filter_query: {},
      comp_key: `11`,
      datatype_id: this.props.match.params.datatype_id,
      loading: true,
      datatype_obj: {},
      expanded_keys: []
    }

    this.list_transaction = RESTExecutor.list().config({
      label: 'file_nottransferred_transactions',
      params: {
        per_page: 100,
        page: 1,
      }
      
    }).forId(this.datatype_id).callbacks(() => { }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.activity);
    this.detail_datatype = RESTExecutor.list().config({
      label: 'datatypes_details',
    }).forId(this.datatype).callbacks((success) => {
      this.setState({ loading: false, datatype_obj: success.result })
      let item = success.result;
      this.list_transaction.forId(this.datatype).config({
        params: {
          ...this.state.filter_query
        }
      }).execute();


    }, (error) => {
      showErrorInNotification(error);
      this.setState({ loading: false })
      // try {
      //     window.header_assigner.assignTitle(`error`);
      // } catch (e) {

      // }
    }).connect(props.domains.allData);

    // this.detail_datatype.execute()

  }
  
  

  render() {
    const { filter_query, loading, datatype_obj, expanded_keys } = this.state;
    if (loading) {
      return <center><Spin /></center>
    }
    console.log(this.list_transaction.response(),'this is data');


    let list_transaction_resp = this.list_transaction.response();
    let detail_datatype_resp = this.detail_datatype.response();
    let rowsData = (list_transaction_resp.result && list_transaction_resp.result.rows) || []
    let rowsMeta = list_transaction_resp.meta || {};

    return (
      <ErrorWrapper
        error={detail_datatype_resp}
        onReload={() => {
          this.detail_datatype.forId(this.datatype).execute()
        }}
      >
        <BasicHeader title={datatype_obj.name} titleType="Datatype"
          subtitle="Packets"
          subtitle2="Not Transferred"
        />
        <ErrorWrapper
          error={list_transaction_resp}
          onReload={() => {
            this.list_transaction.forId(this.state.datatype_id).execute()
          }}
        >
          {filter_query.source_id&&
          <div className='filter-card sticky-content' style={{
            backgroundColor: COLORS.danger_primary,
            top: 56
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between'
            }}>
              <span className='sub-heading-2' style={{
                color: "#fff"
              }}>Source: &nbsp; {filter_query.source_id}</span>
              <Link to={`/activity/data-type/${this.datatype}/packets/forsource?source_id=${filter_query.source_id}&transferred=false`}>
                <span className='sub-heading-2' style={{
                  color: "#fff"
                }}>GO TO SOURCE</span>
              </Link>
            </div>
          </div>
          }
          <div className='default-card' style={{ padding: 0 }}>

            {/* <CustomHeader /> */}
            <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            paddingLeft:'20px',
                            // justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            paddingTop: 4, paddingBottom: 4
                        }}>
                            <FilterFixedInput label="Status">
                                <Select
                                    allowClear
                                    showSearch
                                    className={filter_query.status != null ? 'filter-option-selected' : ''}
                                    style={{
                                    }}
                                    placeholder="Error / All"
                                    value={filter_query.status}
                                    // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={(value, e) => {
                                       console.log({value});
                                       if(value ==='error'){
                                        this.list_transaction.config({
                                          params:{
                                            per_page: 100,
                                            page: 1,
                                            error:true
                                          }
                                        }).execute()
                                       }
                                       else {
                                        this.list_transaction.config({
                                          params:{
                                            per_page: 100,
                                            page: 1,
                                          }
                                        }).execute()
                                       }
                                    }}
                                >
                                    <Select.Option value={'error'}>
                                        Error
                        </Select.Option>
                                    <Select.Option value={'all'}>
                                        All
                        </Select.Option>
                                    {/* <Select.Option value={'true'}>
                                        Transferred
                  </Select.Option> */}
                                </Select>
                            </FilterFixedInput>

                           

                        </div>

            <Table
              scroll={{ x: true }}
              size='small'
              className='main-table no-expand-padding'
              bordered={false}
              loading={list_transaction_resp.fetching}
              columns={transaction_cols({
                onViewDetailClicked: (id) => {
                  this.setState({
                    view_transaction_id: id,
                    view_transaction_modal: true
                  })
                },
                expanded_keys: expanded_keys,
                onExpand: (id) => {
                  this.setState(prevState => ({ expanded_keys: this.state.expanded_keys.includes(id) ? prevState.expanded_keys.filter(x => x !== id) : [...prevState.expanded_keys, id] })
                  )
                }
              })}
              rowKey={(record) => `${record.id}`}
              pagination={{
                // simple: true,
                position: 'bottom',
                onChange: (current, size) => {
                  this.props.history.push({
                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                  })
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                // defaultPageSize: 20,
                pageSize: (rowsMeta && rowsMeta.requested_count),

                total: (rowsMeta && rowsMeta.total_count),
                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
              }}
              dataSource={rowsData}

              // expandable={{
              //   expandedRowRender: record => <div style={{
              //     display: 'flex',
              //     flexDirection: 'column',
              //     borderTop: `1px solid ${COLORS.border_basic}`,
              //   }}>
              //     <Collapse style={{ backgroundColor: 'white' }} bordered={false} expandIconPosition='right'
              //       expandIcon={(panelProps) => {
              //         console.log("props", panelProps.isActive);
              //         return <KeyboardArrowRightOutlined
              //           style={{
              //             color: COLORS.secondary,
              //             transform: `rotate(${panelProps.isActive ? 90 : 0}deg)`,
              //             transition: `all 0.2s ease-in-out`,
              //             top: 12,
              //             fontSize: 20
              //           }}
              //         />
              //       }}
              //     >
              //       <Collapse.Panel header={<span className='sub-heading-3' style={{ color: COLORS.secondary }}>OUR PARSED DATA</span>} key="1">
              //         {record.parsed_data && Object.keys(record.parsed_data).length > 0 &&
              //           <Descriptions className='small-description' bordered size='small' layout='horizontal'>
              //             {Object.keys(record.parsed_data).map((key) => {
              //               if (!key.startsWith('__')) {
              //                 return <Descriptions.Item key={key} label={key} className='log-text' >
              //                   <Paragraph ellipsis={{ expandable: true, rows: 5 }}>
              //                     {typeof record.parsed_data[key] === 'string' ? record.parsed_data[key] : JSON.stringify(record.parsed_data[key])}
              //                   </Paragraph>
              //                 </Descriptions.Item>

              //               }
              //             })}
              //           </Descriptions>
              //         }
              //       </Collapse.Panel>
              //     </Collapse>
              //   </div>,
              //   rowExpandable: record => false,
              //   expandedRowKeys:expanded_keys,
              // }}
              onExpandedRowsChange={(keys)=>{
                this.setState({expanded_keys:keys})
              }}
              expandedRowKeys={expanded_keys}
              expandedRowRender={(record, index, indent, expanded) => {
                let ours = record || {};
                  return <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // borderTop: `1px solid ${COLORS.border_basic}`,
                  }}>
                    {/* <Collapse style={{ backgroundColor: 'white' }} bordered={false} expandIconPosition='right'
                      expandIcon={(panelProps) => {
                        console.log("props", panelProps.isActive);
                        return <KeyboardArrowRightOutlined
                          style={{
                            color: COLORS.secondary,
                            transform: `rotate(${panelProps.isActive ? 90 : 0}deg)`,
                            transition: `all 0.2s ease-in-out`,
                            top: 12,
                            fontSize: 20
                          }}
                        />
                      }}
                    >
                      <Collapse.Panel header={<span className='sub-heading-3' style={{ color: COLORS.secondary }}>PARSED DATA</span>} key="1"> */}
                        {ours.parsed_data && Object.keys(ours.parsed_data).length > 0 &&
                          <Descriptions className='small-description' bordered size='small' layout='horizontal'>
                            {Object.keys(ours.parsed_data).map((key) => {
                              if (!key.startsWith('__')) {
                                return <Descriptions.Item key={key} label={key} className='log-text' >
                                  <Paragraph >
                                    {typeof ours.parsed_data[key] === 'string' ? ours.parsed_data[key] : JSON.stringify(ours.parsed_data[key])}
                                  </Paragraph>
                                </Descriptions.Item>

                              }
                            })}
                          </Descriptions>
                        }
                      {/* </Collapse.Panel> */}
                      {/* <Collapse.Panel header={<span className='sub-heading-3' style={{ color: COLORS.secondary }}>RAW DATA</span>} key="2">
                        {ours.parsed_data && Object.keys(ours.parsed_data).length > 0 &&
                          <Descriptions className='small-description' bordered size='small' layout='horizontal'>
                            {Object.keys(ours.parsed_data).map((key) => {
                              if (!key.startsWith('__')) {
                                return <Descriptions.Item key={key} label={key} className='log-text' >
                                  <Paragraph >
                                    {typeof ours.parsed_data[key] === 'string' ? ours.parsed_data[key] : JSON.stringify(ours.parsed_data[key])}
                                  </Paragraph>
                                </Descriptions.Item>

                              }
                            })}
                          </Descriptions>
                        }
                      </Collapse.Panel> */}
                      
                    {/* </Collapse> */}
                  </div>
              }}
            />


          </div>
        </ErrorWrapper>
      </ErrorWrapper>
    );
  }

  componentWillReceiveProps(nextProps) {
    var olddatatype_id = this.props.match.params.datatype_id;
    var newdatatype_id = nextProps.match.params.datatype_id;




    if (olddatatype_id !== newdatatype_id || (this.props.location.search !== nextProps.location.search)) {
      this.datatype = newdatatype_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...parsed
        },
        expanded_keys: []
      }, () => {
        if (olddatatype_id !== newdatatype_id) {
          this.setState({
            loading: true
          }, () => {
            this.detail_datatype.forId(this.datatype).execute()
          })
        } else {
          this.list_transaction.forId(this.datatype).config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }



      })

    }
  }


  componentDidMount() {


    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      },
      expanded_keys: []
    }, () => {
      this.detail_datatype.execute()
    })
  }
}

export default withDomains(FileNotTransferredTransactions, "activity", "allData");
